import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { RpUserPropertyBundle } from "@idw-types/data/axn-admin-user/rp-user-property-bundle";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";

export const createUserRequest = async (
    firstName: string,
    lastName: string,
    email: string,
    credential: string,
    apiUserName: string,
    apiPassword: string,
    axnCompanyId: string,
    identityProviderId: string,
    userPropertyBundleId: string,
    rpUserPropertyBundles: Array<RpUserPropertyBundle>
): Promise<GenericNetworkResponse<Array<AxnAdminUser>>> => {
    const route = apiRoutes.axnadminCore.users;
    const body = {
        firstName,
        lastName,
        email,
        credential,
        apiUserName,
        apiPassword,
        organizationID: axnCompanyId,
        identityProviderID: identityProviderId,
        userPropertyBundleID: rpUserPropertyBundles.length > 0 ? null : userPropertyBundleId,
        rpUserPropertyBundles: rpUserPropertyBundles.length > 0 ? JSON.stringify(rpUserPropertyBundles) : null
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};